import {observer} from 'mobx-react';
import {t, withState} from 'shared/core';
import {UserSettingsState} from 'main/containers/users/settings/state';
import {Layout, Panel, Display} from 'shared/components';
import {
  EmailPreferencesContainer,
  PrivacySettingsContainer,
  SchedulingIntegrations,
  SlackIntegration
} from 'main/containers/users/settings';
import {AuthSettings} from 'shared/components/auth_settings';
import {auth} from 'main/tools';

const UsersSettingsContainer = observer(({uiState}) => {
  return (
    <div>
      <Display title={t('user_settings.Personal Settings')}/>
      <Layout>
        <Layout.Section>
          <Panel.Stack loose>
            {!auth.user.hideAuthSettings && <AuthSettings uiState={uiState}/>}
            <SlackIntegration uiState={uiState}/>
            <SchedulingIntegrations uiState={uiState}/>
            <EmailPreferencesContainer uiState={uiState}/>
            <PrivacySettingsContainer uiState={uiState}/>
          </Panel.Stack>
        </Layout.Section>
      </Layout>
    </div>
  );
});

export default withState(UsersSettingsContainer, UserSettingsState);
